var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImageButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.25008H1.5V14.1667C1.5 14.953 2.175 15.5834 3 15.5834H13.5V14.1667H3V4.25008ZM13.875 10.0938C13.875 9.03133 11.625 8.50008 10.5 8.50008C9.375 8.50008 7.125 9.03133 7.125 10.0938V10.6251H13.875V10.0938ZM10.5 7.2605C11.43 7.2605 12.1875 6.54508 12.1875 5.66675C12.1875 4.78841 11.43 4.073 10.5 4.073C9.57 4.073 8.8125 4.78841 8.8125 5.66675C8.8125 6.54508 9.57 7.2605 10.5 7.2605ZM15 1.41675H6C5.175 1.41675 4.5 2.05425 4.5 2.83341V11.3334C4.5 12.1197 5.175 12.7501 6 12.7501H15C15.8325 12.7501 16.5 12.1197 16.5 11.3334V2.83341C16.5 2.04716 15.825 1.41675 15 1.41675ZM15 11.3334H6V2.83341H15V11.3334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageButtonIcon);
export default __webpack_public_path__ + "static/media/upload-image-button-icon.073a4d57.svg";
export { ForwardRef as ReactComponent };